export default __webpack_public_path__ + "static/media/history2.7bcef9fb.png";